import { EMPTY_LOGO_URLS } from '@/components/CompanyConfiguration/constants';

export default function isEmptyLogoUrl(logoUrl = '') {
  return EMPTY_LOGO_URLS.some((key) => logoUrl.includes(key));
}
